module.exports = __webpack_public_path__ + "static/media/Volatility-newest-png-crop.8ddc2a1c.png";